import { z } from 'zod';

/**
 * Validates URL parameters using Zod schemas
 * @param {object} params - Parameters to validate
 * @param {z.ZodSchema} schema - Zod schema for validation
 * @returns {object|null} Validated parameters or null if validation fails
 */
export const validateUrlParams = (params, schema) => {
  try {
    return schema.parse(params);
  } catch (error) {
    console.error('Invalid URL parameters:', error);
    return null;
  }
};

/**
 * Common URL parameter schemas for validation
 */
export const urlParamSchemas = {
  token: z.string().min(10).max(500),
  linkgen: z.string().min(10).max(1000),
  key: z.string().min(1).max(100),
  EncryptedData: z.string().min(1).max(2000),
  planId: z.string().uuid().optional(),
  orgId: z.string().uuid().optional(),
};

/**
 * Parameter value exactly as in the query string (percent-encoding kept: %2b, %2f, …).
 * Use when the API must receive the same bytes as in the href, not URLSearchParams.get()
 * which decodes to +, /, = and can break validation for some backends.
 *
 * @param {string} search - window.location.search (includes leading ?)
 * @param {string} name - query parameter name
 * @returns {string|null}
 */
export function getRawQueryParamValue(search, name) {
  if (search == null || search === '' || !name) return null;
  const esc = name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const re = new RegExp(`(?:^|[?&])${esc}=([^&]*)`);
  const m = String(search).match(re);
  return m ? m[1] : null;
}
